import { LANGUAGE } from '../config/constant'

export const getLanguage = () => {
  return localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language')) : LANGUAGE
}

export const keyify = (obj, prefix = '', postfix = '') =>
  Object.entries(obj).reduce((res, el) => {
    if (Array.isArray(el[1])) {
      return [...res, ...keyify(el[1], `${prefix}${el[0]}[`, ']')]
    } else if (el[1] instanceof File) {
      return [...res, { key: prefix + el[0] + postfix, value: el[1] }]
    } else if (typeof el[1] === 'object' && el[1] !== null) {
      return [...res, ...keyify(el[1], prefix + el[0] + postfix + '[', ']')]
    }
    return [...res, { key: prefix + el[0] + postfix, value: el[1] }]
  }, [])

export const objectToFormData = (object = {}) => {
  const allKeys = keyify(object)
  const formData = new FormData()

  for (const key in allKeys) {
    formData.append(allKeys[key].key, allKeys[key].value)
  }
  return formData
}

const defaultRoute = { name: null, params: {} }
export const getLastRoute = () => {
  return localStorage.getItem('LastRoute') ? JSON.parse(localStorage.getItem('LastRoute')) : defaultRoute
}
export const setLastRoute = (rote = defaultRoute) => {
  const theLastRoute = {
    name: rote.name ? rote.name : defaultRoute.name,
    params: rote.params ? rote.params : defaultRoute.params
  }
  localStorage.setItem('LastRoute', JSON.stringify(theLastRoute))
}
